export default "__VITE_ASSET__XKLr7$Qh__"